import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ReferenceInputEnumSearch from 'customer-data-reference-ui-components/enum/ReferenceInputEnumSearch';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverSearchType from 'reference-resolvers/schema/ReferenceResolverSearchType';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { formatWithEmail } from 'customer-data-objects/owners/FormatOwnerName';
import OwnerRecord from 'customer-data-objects/owners/OwnerRecord';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  handleUserOpenChange: PropTypes.func.isRequired,
  isUserFilterOpen: PropTypes.bool,
  onChange: PropTypes.func,
  value: ImmutablePropTypes.list.isRequired,
  resolver: ReferenceResolverSearchType.isRequired
};
export const ownerFormatter = owner => {
  const record = OwnerRecord.fromJS(owner.referencedObject.toJS());
  const text = formatWithEmail(record);
  return {
    text,
    value: String(owner.id),
    title: text
  };
};
class TimelineFilterOwners extends PureComponent {
  constructor(props) {
    super(props);
    this.renderButtonContent = this.renderButtonContent.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
  }
  handleOnChange(evt) {
    this.props.onChange(evt.target.value);
  }
  renderButtonContent() {
    const {
      value
    } = this.props;
    if (!value || !value.size) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "timeline.filters.users.noneSelected"
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "timeline.filters.users.selected",
      options: {
        count: value.size
      }
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
        children: /*#__PURE__*/_jsx("div", {
          id: "timeline-activities-users-select",
          children: /*#__PURE__*/_jsx("label", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "timeline.filters.accessibility.users"
            })
          })
        })
      }), /*#__PURE__*/_jsx(ReferenceInputEnumSearch, {
        "aria-labelledby": "timeline-activities-users-select",
        ButtonContent: this.renderButtonContent,
        buttonUse: "transparent",
        "data-selenium-test": "timeline-filter-users",
        menuWidth: "auto",
        multi: true,
        onChange: this.handleOnChange,
        onOpenChange: this.props.handleUserOpenChange,
        open: this.props.isUserFilterOpen,
        optionFormatter: ownerFormatter,
        placeholder: I18n.text('timeline.filters.users.noneSelected'),
        resolver: this.props.resolver,
        showTags: false,
        value: this.props.value.toArray()
      })]
    });
  }
}
TimelineFilterOwners.propTypes = propTypes;
export const mapResolversToProps = (resolvers = {}) => {
  return {
    resolver: resolvers.OWNER
  };
};
export const UnconnectedTimelineFilterOwners = TimelineFilterOwners;
export default ConnectReferenceResolvers(mapResolversToProps, TimelineFilterOwners);